var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: [_vm.$style["mds-section"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "div",
        _vm._g(
          {
            class: [
              _vm.$style["mds-section__header-container"],
              _vm.headerClasses,
              _vm.sizeClass,
            ],
            attrs: {
              tabindex: _vm.tabIndex,
              "aria-expanded": _vm.ariaExpanded,
              "aria-controls": _vm.collapsible ? _vm.expandedId : null,
              role: _vm.collapsible ? "button" : null,
            },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.toggle($event)
              },
            },
          },
          _vm.headerEvents
        ),
        [
          _vm.collapsible
            ? _c("mds-icon", {
                class: _vm.$style["mds-section__toggle"],
                attrs: { name: "triangle-fill-right", size: _vm.iconSize },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            _vm.headingType,
            { tag: "component", class: _vm.$style["mds-section__title"] },
            [
              _vm._t("mds-section-title", function () {
                return [_vm._v(_vm._s(_vm.title))]
              }),
              _vm._v(" "),
              _vm.hasTitleDescription
                ? _c(
                    "div",
                    { class: _vm.$style["mds-section__title-description"] },
                    [_vm._t("mds-section-title-description")],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.$scopedSlots["mds-section-supplemental-content"]
            ? _c(
                "div",
                { class: _vm.$style["mds-section__supplemental-content"] },
                [_vm._t("mds-section-supplemental-content")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$scopedSlots["mds-section-actions"]
            ? _c(
                "div",
                {
                  class: _vm.$style["mds-section__actions"],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_vm._t("mds-section-actions")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsible || (_vm.open && _vm.collapsible),
              expression: "!collapsible || (open && collapsible)",
            },
          ],
          class: _vm.$style["mds-section__content"],
          attrs: { id: _vm.collapsible ? _vm.expandedId : null },
        },
        [
          _vm.content
            ? [_c("span", { domProps: { innerHTML: _vm._s(_vm.content) } })]
            : [_vm._t("default")],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }